import {
  FETCH_TEACHER_COURSES_REQUEST,
  FETCH_TEACHER_COURSES_SUCCESS,
  FETCH_TEACHER_COURSES_FAILURE,
} from "../Actions/adminDeveloperTeacherCoursesAction";

const initialState = { loading: false, data: [], error: "" };

const teacherCoursesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TEACHER_COURSES_REQUEST:
      return { ...state, loading: true };
    case FETCH_TEACHER_COURSES_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: "" };
    case FETCH_TEACHER_COURSES_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};
export default teacherCoursesReducer;
